<template>
  <div class="licensed-devices-container">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Licensed Devices</h5>
      <a-input-search
        v-model:value="searchText"
        placeholder="Search devices..."
        style="width: 200px"
        allow-clear
      />
    </div>

    <a-table
      :columns="columns"
      :data-source="filteredDevices"
      :loading="loading"
      :pagination="pagination"
      bordered
      :scroll="{ x: 800 }"
      row-key="id"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'display_name'">
          {{ record.display_name || record.device_name || '-' }}
        </template>
        <template v-if="column.key === 'assigned_at'">
          {{ record.assigned_at ? formatDate(record.assigned_at) : '-' }}
        </template>
        <template v-if="column.key === 'assigned_by'">
          {{ record.assigned_by || '-' }}
        </template>
      </template>
      <template #emptyText>
        <a-empty description="No licensed devices found" />
      </template>
    </a-table>
  </div>
</template>

<script>
export default {
  name: 'LicensedDevicesTable',
  props: {
    devices: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
      pagination: {
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total) => `Total ${total} licensed devices`,
      },
      columns: [
        {
          title: 'Device Name',
          dataIndex: 'display_name',
          key: 'display_name',
          width: '25%',
        },
        {
          title: 'Serial Number',
          dataIndex: 'serial_number',
          key: 'serial_number',
          width: '20%',
        },

        {
          title: 'Assigned Date',
          dataIndex: 'assigned_at',
          key: 'assigned_at',
          width: '18%',
        },
        // {
        //   title: 'Assigned By',
        //   dataIndex: 'assigned_by',
        //   key: 'assigned_by',
        //   width: '17%',
        // },
      ],
    };
  },
  computed: {
    filteredDevices() {
      if (!this.searchText) return this.devices;
      const search = this.searchText.toLowerCase();
      return this.devices.filter(
        (device) =>
          device.device_name?.toLowerCase().includes(search) ||
          device.display_name?.toLowerCase().includes(search) ||
          device.serial_number?.toLowerCase().includes(search)
      );
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>

<style scoped>
.licensed-devices-container {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
